module.exports = __webpack_public_path__ + "static/media/chess-clock-alt.2cdcef88.svg";